export default class Modale {
  constructor(element) {
    this.element = element;

    this.modales = this.element.querySelectorAll('.js-modale');
    this.modalesProjet = this.element.querySelector('.js-modale-projet');
    this.modalesProfil = this.element.querySelector('.js-modale-profil');
    this.modalesContact = this.element.querySelector('.js-modale-contact');
    this.navAccueil = this.element.querySelector('.accueil__navigation');
    this.boutons = this.element.querySelectorAll('.js-fermer');
    this.boutonsMobile = this.element.querySelectorAll('.js-fermer-mobile');
    this.mobiles = this.element.querySelectorAll('.js-modale-mobile');
    this.contents = this.element.querySelectorAll(`[data-modale-content-id]`);

    this.init();
  }

  init() {
    for (let i = 0; i < this.modales.length; i++) {
      const modale = this.modales[i];
      modale.addEventListener('click', this.ouvrirModale.bind(this));
    }

    this.ouvrirModalesAccueil();

    for (let i = 0; i < this.boutons.length; i++) {
      const bouton = this.boutons[i];
      bouton.addEventListener('click', this.fermerModale.bind(this));
    }
    for (let i = 0; i < this.boutonsMobile.length; i++) {
      const bouton = this.boutonsMobile[i];
      bouton.addEventListener('click', this.fermerModaleMobile.bind(this));
    }
  }
  ouvrirModale(event) {
    //console.log('Initialisation de ma composante Modale');
    const id = event.currentTarget.dataset.modaleId;
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      content.classList.remove('modale-is-active');
      if (content.dataset.modaleContentId == id) {
        content.classList.add('modale-is-active');
      }
    }
  }
  fermerModale() {
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      content.classList.remove('modale-is-active');
    }
  }
  fermerModaleMobile() {
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      content.classList.remove('modale-is-active--mobile');
    }
    if (window.matchMedia('(max-width: 800px)').matches) {
      this.navAccueil.classList.remove('nav-is-inactive');
    }
  }

  ouvrirModalesAccueil() {
    this.modalesProjet.addEventListener(
      'click',
      this.ouvrirModaleProjets.bind(this)
    );
    this.modalesProfil.addEventListener(
      'click',
      this.ouvrirModaleProfil.bind(this)
    );
    this.modalesContact.addEventListener(
      'click',
      this.ouvrirModaleContact.bind(this)
    );
  }

  /*------------Code boboche à changer un jour--------------*/
  ouvrirModaleProjets() {
    const modale = this.element.querySelector('.modaleProjets');
    //Breakpoint tablette
    if (window.matchMedia('(max-width: 800px)').matches) {
      for (let i = 0; i < this.mobiles.length; i++) {
        const mobile = this.mobiles[i];
        mobile.classList.remove('modale-is-active--projets');
        mobile.classList.remove('modale-is-active--profil');
        mobile.classList.remove('modale-is-active--contact');
        mobile.classList.remove('modale-is-active--mobile');
      }
      this.navAccueil.classList.add('nav-is-inactive');
      modale.classList.add('modale-is-active--mobile');
    } else {
      modale.classList.add('modale-is-active--projets');
    }
  }
  ouvrirModaleProfil() {
    const modale = this.element.querySelector('.modaleProfil');
    //Breakpoint tablette
    if (window.matchMedia('(max-width: 800px)').matches) {
      for (let i = 0; i < this.mobiles.length; i++) {
        const mobile = this.mobiles[i];
        mobile.classList.remove('modale-is-active--projets');
        mobile.classList.remove('modale-is-active--profil');
        mobile.classList.remove('modale-is-active--contact');
        mobile.classList.remove('modale-is-active--mobile');
      }
      this.navAccueil.classList.add('nav-is-inactive');
      modale.classList.add('modale-is-active--mobile');
    } else {
      modale.classList.add('modale-is-active--profil');
    }
  }
  ouvrirModaleContact() {
    const modale = this.element.querySelector('.modaleContact');
    //Breakpoint tablette
    if (window.matchMedia('(max-width: 800px)').matches) {
      for (let i = 0; i < this.mobiles.length; i++) {
        const mobile = this.mobiles[i];
        mobile.classList.remove('modale-is-active--projets');
        mobile.classList.remove('modale-is-active--profil');
        mobile.classList.remove('modale-is-active--contact');
        mobile.classList.remove('modale-is-active--mobile');
      }
      this.navAccueil.classList.add('nav-is-inactive');
      modale.classList.add('modale-is-active--mobile');
    } else {
      modale.classList.add('modale-is-active--contact');
    }
  }
}
